import { Recipe } from '../../api/Recipe';
import useRecipeRealtimeSync from './useRecipeRealtimeSync';

interface UseRecipeListSyncOptions {
  setAllRecipes: React.Dispatch<React.SetStateAction<Recipe[]>>;
}

export const useRecipeListSync = ({
  setAllRecipes,
}: UseRecipeListSyncOptions): void => {
  useRecipeRealtimeSync({ setAllRecipes });
};

export default useRecipeListSync;
